import styled from 'styled-components';
import { Link } from 'gatsby';
import logo from '@/images/logo.png';
import { mediaQuery } from '@/styles/media';

const Pc = styled.h1<{ $isSticky: boolean }>`
  display: ${(props) => (props.$isSticky ? 'none' : 'inline')};

  ${mediaQuery.sp} {
    display: none;
  }
`;

const Sp = styled.h1<{ $isSticky: boolean }>`
  display: ${(props) => (props.$isSticky ? 'inline' : 'none')};

  ${mediaQuery.sp} {
    display: inline;
  }
`;

type Props = {
  isSticky?: boolean;
};

const HeaderLogo: React.FC<Props> = ({ isSticky = false }) => {
  return (
    <Link to="/">
      <Pc $isSticky={isSticky}>
        <img
          src={logo}
          alt="POSTD PRODUCED BY NIJIBOX"
          width={160}
          height={75}
        />
      </Pc>
      <Sp $isSticky={isSticky}>
        <img
          src={logo}
          alt="POSTD PRODUCED BY NIJIBOX"
          width={96}
          height={45}
        />
      </Sp>
    </Link>
  );
};

export default HeaderLogo;
